import React, { useState } from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import { Stack } from '@atlaskit/primitives/compiled';
import Heading from '@atlaskit/heading';

import type { Category } from '@confluence/category-selector';

import { useSnippets } from '../store/snippetsStore.ts';
import { SnippetsPanelSearchBar } from './SnippetsPanelSearchBar.tsx';
import { SnippetCategoryId, SnippetCategorySelector } from './SnippetCategorySelector.tsx';
import { SnippetPanelList } from './SnippetPanelList.tsx';
import { SnippetPanelSkeleton } from './skeleton/SnippetPanelSkeleton.tsx';

const messages = defineMessages({
	snippetsRecommended: {
		id: 'snippets.panel.recommended',
		defaultMessage: 'Recommended',
		description: 'Header for the list of Block Templates within the right panel',
	},
});

export const SnippetPanel = () => {
	const [{ snippets, isLoading }] = useSnippets();

	const [searchQuery, setSearchQuery] = useState('');
	const handleSearchChange = (value: string) => {
		setSearchQuery(value);
	};

	const initialCategory = SnippetCategoryId.ALL;
	const [selectedCategoryId, setSelectedCategoryId] = useState<SnippetCategoryId>(initialCategory);
	const handleCategoryChange = (category: Category) => {
		setSelectedCategoryId(category.id as SnippetCategoryId);
	};

	const shouldShowRecommended = selectedCategoryId === SnippetCategoryId.ALL && searchQuery === '';

	return isLoading ? (
		<SnippetPanelSkeleton />
	) : (
		<Stack space="space.200" grow="fill">
			<SnippetsPanelSearchBar onChange={handleSearchChange} />
			<SnippetCategorySelector
				initialCategoryId={initialCategory}
				onSelectionChange={handleCategoryChange}
			/>
			{shouldShowRecommended && (
				<Heading size="xxsmall">
					<FormattedMessage {...messages.snippetsRecommended} />
				</Heading>
			)}
			<SnippetPanelList snippets={snippets} />
		</Stack>
	);
};
